import { ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE } from 'fhir/constants'

export const PATIENT_AUTHORIZED_LOCATION_1_EXTENSION = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/authorized-location-1`
export const PATIENT_AUTHORIZED_LOCATION_2_EXTENSION = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/authorized-location-2`

export const PERMISSABLE_LOCATION_VARIANCE_IN_FT = 4000
